import { StyleParamType, wixFontParam, wixColorParam, } from '@wix/tpa-settings';
export var searchResultsStyles = {
    searchBarBackgroundColor: {
        type: StyleParamType.Color,
        name: 'searchBarBackgroundColor',
        getDefaultValue: wixColorParam('color-1'),
    },
    searchBarBorderWidth: {
        type: StyleParamType.Number,
        name: 'searchBarBorderWidth',
        getDefaultValue: function () { return 1; },
    },
    searchBarBorderColor: {
        type: StyleParamType.Color,
        name: 'searchBarBorderColor',
        getDefaultValue: wixColorParam('color-5', 0.6),
    },
    searchBarTextFont: {
        type: StyleParamType.Font,
        name: 'searchBarTextFont',
        getDefaultValue: wixFontParam('Body-M', {
            size: 20,
        }),
    },
    searchBarTextFontColor: {
        type: StyleParamType.Color,
        name: 'searchBarTextFontColor',
        getDefaultValue: wixColorParam('color-5'),
    },
    searchBarIconColor: {
        type: StyleParamType.Color,
        name: 'searchBarIconColor',
        getDefaultValue: wixColorParam('color-5', 0.6),
    },
    // --
    resultsMenuTextFont: {
        type: StyleParamType.Font,
        name: 'resultsMenuTextFont',
        getDefaultValue: wixFontParam('Body-M', {
            size: 16,
        }),
    },
    resultsMenuTextFontColor: {
        type: StyleParamType.Color,
        name: 'resultsMenuTextFontColor',
        getDefaultValue: wixColorParam('color-5'),
    },
    resultsMenuBorderColor: {
        type: StyleParamType.Color,
        name: 'resultsMenuBorderColor',
        getDefaultValue: wixColorParam('color-5'),
    },
    resultsMenuSelectedBorderColor: {
        type: StyleParamType.Color,
        name: 'resultsMenuSelectedBorderColor',
        getDefaultValue: wixColorParam('color-8'),
    },
    resultsTitleFont: {
        type: StyleParamType.Font,
        name: 'resultsTitleFont',
        getDefaultValue: wixFontParam('Heading-M', {
            size: 20,
        }),
    },
    resultsTitleFontColor: {
        type: StyleParamType.Color,
        name: 'resultsTitleFontColor',
        getDefaultValue: wixColorParam('color-5'),
    },
    resultsDescriptionFont: {
        type: StyleParamType.Font,
        name: 'resultsDescriptionFont',
        getDefaultValue: wixFontParam('Body-M', {
            size: 14,
        }),
    },
    resultsDescriptionFontColor: {
        type: StyleParamType.Color,
        name: 'resultsDescriptionFontColor',
        getDefaultValue: wixColorParam('color-5'),
    },
    resultsMessageFont: {
        type: StyleParamType.Font,
        name: 'resultsMessageFont',
        getDefaultValue: wixFontParam('Body-M', {
            size: 14,
        }),
    },
    resultsMessageFontColor: {
        type: StyleParamType.Color,
        name: 'resultsMessageFontColor',
        getDefaultValue: wixColorParam('color-5'),
    },
    resultsHighlightColor: {
        type: StyleParamType.Color,
        name: 'resultsHighlightColor',
        getDefaultValue: wixColorParam('color-8'),
    },
    resultsHighlightFont: {
        type: StyleParamType.Font,
        name: 'resultsHighlightFont',
        getDefaultValue: wixFontParam('Body-M', {
            size: 20,
        }),
    },
    resultsHighlightFontColor: {
        type: StyleParamType.Color,
        name: 'resultsHighlightFontColor',
        getDefaultValue: wixColorParam('color-5'),
    },
    paginationTextFont: {
        type: StyleParamType.Font,
        name: 'paginationTextFont',
        getDefaultValue: wixFontParam('Body-M', {
            size: 16,
        }),
    },
    paginationTextFontColor: {
        type: StyleParamType.Color,
        name: 'paginationTextFontColor',
        getDefaultValue: wixColorParam('color-5'),
    },
    paginationSelectedTextFontColor: {
        type: StyleParamType.Color,
        name: 'paginationSelectedTextFontColor',
        getDefaultValue: wixColorParam('color-8', 0.6),
    },
};
//# sourceMappingURL=searchResultsStyles.js.map